frappe.ready(function () {
	var isAllProductsPage = window.location && window.location.pathname === "/all-products";
	var isItemGroupListing = Boolean(document.querySelector('.item-group-content[data-item-group]'));
	var hasListingRoot = Boolean(document.getElementById('product-listing'));
	if (!isAllProductsPage && !isItemGroupListing && !hasListingRoot) {
		return;
	}

  var offersCache = {};
  var inflightRequest = false;

  // "Ends Sep 6" - informational only, no live countdown (that's the
  // separate Sale-badge widget in raftor_websitehq's product card system).
  function formatOfferEndDate(endDate) {
    var ts = Date.parse(endDate);
    if (isNaN(ts)) return '';
    return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }

  function getCardItemCode(card) {
    if (!card) return null;
    return card.getAttribute('data-item-code') ||
      (card.querySelector('[data-item-code]') && card.querySelector('[data-item-code]').getAttribute('data-item-code')) ||
      null;
  }

  function injectProductOffers() {
    var listing = document.getElementById('product-listing');
    if (!listing) return;

    var cards = listing.querySelectorAll('.item-card');
    var unprocessedCards = Array.prototype.filter.call(cards, function (card) {
      return !card.hasAttribute('data-offers-checked');
    });

    if (!unprocessedCards.length) return;

    var codesSet = new Set();
    unprocessedCards.forEach(function (card) {
      var code = getCardItemCode(card);
      if (code) codesSet.add(code);
    });

    var itemCodes = Array.from(codesSet);
    if (!itemCodes.length) return;

    function applyOffers() {
      unprocessedCards.forEach(function (card) {
        var code = getCardItemCode(card);
        if (!code) return;
        var offers = offersCache[code];

        // Mark as checked regardless (prevents repeated API calls if no offers)
        card.setAttribute('data-offers-checked', '1');

        if (!offers || !offers.length) return;
        if (card.querySelector('.offer-container')) return;

        var priceEl = card.querySelector('.product-price');
        if (!priceEl) return;

        var container = document.createElement('div');
        container.className = 'offer-container';

        var heading = document.createElement('div');
        heading.className = 'offers-heading mb-2';
        heading.innerHTML = '<span class="mr-1 tag-icon">' +
          '<svg class="icon icon-lg"><use href="#icon-tag"></use></svg>' +
          '</span><b>' + __('Available Offers') + '</b>';

        var listWrap = document.createElement('div');
        offers.forEach(function (o) {
          var line = document.createElement('div');
          line.className = 'offer-line mt-2 d-flex';

          var icon = document.createElement('div');
          icon.className = 'offer-line-icon';
          icon.innerHTML =
            '<svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M19 15.6213C19 15.2235 19.158 14.842 19.4393 14.5607L20.9393 13.0607C21.5251 12.4749 21.5251 11.5251 20.9393 10.9393L19.4393 9.43934C19.158 9.15804 19 8.7765 19 8.37868V6.5C19 5.67157 18.3284 5 17.5 5H15.6213C15.2235 5 14.842 4.84196 14.5607 4.56066L13.0607 3.06066C12.4749 2.47487 11.5251 2.47487 10.9393 3.06066L9.43934 4.56066C9.15804 4.84196 8.7765 5 8.37868 5H6.5C5.67157 5 5 5.67157 5 6.5V8.37868C5 8.7765 4.84196 9.15804 4.56066 9.43934L3.06066 10.9393C2.47487 11.5251 2.47487 12.4749 3.06066 13.0607L4.56066 14.5607C4.84196 14.842 5 15.2235 5 15.6213V17.5C5 18.3284 5.67157 19 6.5 19H8.37868C8.7765 19 9.15804 19.158 9.43934 19.4393L10.9393 20.9393C11.5251 21.5251 12.4749 21.5251 13.0607 20.9393L14.5607 19.4393C14.842 19.158 15.2235 19 15.6213 19H17.5C18.3284 19 19 18.3284 19 17.5V15.6213Z" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M15 9L9 15" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M10.5 9.5C10.5 10.0523 10.0523 10.5 9.5 10.5C8.94772 10.5 8.5 10.0523 8.5 9.5C8.5 8.94772 8.94772 8.5 9.5 8.5C10.0523 8.5 10.5 8.94772 10.5 9.5Z" fill="white" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M15.5 14.5C15.5 15.0523 15.0523 15.5 14.5 15.5C13.9477 15.5 13.5 15.0523 13.5 14.5C13.5 13.9477 13.9477 13.5 14.5 13.5C15.0523 13.5 15.5 8.94772 15.5 14.5Z" fill="white" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>';

          // Built via textContent, not string-concatenated into innerHTML -
          // offer_title/offer_subtitle are admin-authored but still
          // untrusted-enough free text to not splice straight into markup.
          var text = document.createElement('p');
          text.className = 'offer-line-text mb-0';
          text.appendChild(document.createTextNode(
            __(o.offer_title || '') + (o.offer_subtitle ? (': ' + __(o.offer_subtitle)) : '')
          ));
          if (o.end_date) {
            var endLabel = formatOfferEndDate(o.end_date);
            if (endLabel) {
              var expiry = document.createElement('span');
              expiry.className = 'offer-line-expiry';
              expiry.textContent = __('Ends') + ' ' + endLabel;
              text.appendChild(expiry);
            }
          }

          line.appendChild(icon);
          line.appendChild(text);
          listWrap.appendChild(line);
        });

        var wrapper = document.createElement('div');
        wrapper.className = 'mt-2';
        wrapper.appendChild(heading);
        wrapper.appendChild(container);
        wrapper.appendChild(listWrap);

        if (priceEl.nextSibling) {
          priceEl.parentNode.insertBefore(wrapper, priceEl.nextSibling);
        } else {
          priceEl.parentNode.appendChild(wrapper);
        }
      });
    }

    var missingCodes = itemCodes.filter(function (c) { return !offersCache[c]; });
    if (!missingCodes.length) {
      applyOffers();
      return;
    }

    if (inflightRequest) return;
    inflightRequest = true;

    frappe.call({
      method: 'raftor_webhq.catalog.api.get_item_offers',
      args: { item_codes: missingCodes },
      callback: function (r) {
        inflightRequest = false;
        if (r && r.message) {
          Object.keys(r.message).forEach(function (code) {
            offersCache[code] = r.message[code];
          });
        }
        // Ensure missing codes are still cached to avoid repeated lookups
        missingCodes.forEach(function (c) {
          if (!offersCache[c]) offersCache[c] = [];
        });

        applyOffers();
      }
    });
  }

  // Initial try after grid renders
  setTimeout(injectProductOffers, 600);

  // Re-run after infinite scroll appends items
  document.addEventListener('products-loaded', function () {
    setTimeout(injectProductOffers, 50);
  });

  // Observe product listing for changes (e.g. filters, sorting) and re-inject offers.
  var observerInitialized = false;
  function setupOffersObserver() {
    if (observerInitialized) return;
    var listing = document.getElementById('product-listing');
    if (!listing) return;

    observerInitialized = true;
    var timeoutId = null;
    window.webhqDom.onAdded(function (roots) {
      var touchesListing = roots.some(function (r) {
        return r === listing || listing.contains(r) || r.contains(listing);
      });
      if (!touchesListing) return;
      // Debounce rapid DOM changes into a single inject call
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(injectProductOffers, 600);
    });
  }

  setTimeout(setupOffersObserver, 800);
});
